export default "__VITE_ASSET__271a97a3__"